/**
 * Returns the version inserted into the page via HtmlWebpackPlugin
 */
const getVersion = () => (document.querySelector('meta[name=bporversion]') || {}).content || '';

export default getVersion;
